import { render } from "./PendingBackToPharmacy.vue?vue&type=template&id=119a5b64"
import script from "./PendingBackToPharmacy.vue?vue&type=script&lang=js"
export * from "./PendingBackToPharmacy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__